<script lang="ts" setup>
import boxIcon from '~/assets/static-img/error/box.svg?url'
import humanIcon from '~/assets/static-img/error/human.svg?url'
import AppButton from '~/components/ui/buttons/AppButton.vue'
import MainTitle from '~/components/ui/title/MainTitle.vue'

interface IErrorPreset {
  [key: string]: {
    code: string
    title: string
    subtitle: string
    image: string
    link: string | null
    component?: Component
  }
}

const error = ref<any>(useError())
const errorPresets:IErrorPreset = {
  204: {
    ...error.value.data,
    image: boxIcon,
    link: '/',
  },
  400: {
    code: '400',
    title: 'Неверный запрос',
    subtitle: 'Проверьте корректность введенной ссылки и обновите страницу',
    image: humanIcon,
    link: null,
  },
  403: {
    code: '403',
    title: 'Доступ запрещён',
    subtitle: 'У вас нет разрешения на доступ к этой странице',
    image: humanIcon,
    link: null,
  },
  404: {
    code: '404',
    title: 'Такой страницы не существует',
    subtitle: 'В адресе страницы есть ошибка или она удалена',
    image: boxIcon,
    link: '/',
  },
  500: {
    code: '500',
    title: 'Внутренняя ошибка сервера',
    subtitle:
      'Мы знаем о проблеме и работаем над её решением. Извините за неудобства.',
    image: humanIcon,
    link: null,
  },
  502: {
    code: '502',
    title: 'Сервер перегружен',
    subtitle: 'Попробуйте обновить страницу или очистить кэш',
    image: humanIcon,
    link: null,
  },
  503: {
    code: '503',
    title: 'Сервис временно недоступен',
    subtitle: 'Попробуйте обновить страницу или очистить кэш',
    image: humanIcon,
    link: null,
  },
  504: {
    code: '504',
    title: 'Время ожидания ответа истекло',
    subtitle: 'Попробуйте обновить страницу позже',
    image: humanIcon,
    link: null,
  },
  505: {
    code: '505',
    title: 'Сервис временно недоступен',
    subtitle: 'Попробуйте очистить куки-файлы, кэш и обновить страницу',
    image: humanIcon,
    link: null,
  },
}

if (error.value?.statusCode === 204 && error.value?.data?.component) {
  errorPresets[204].component = error.value.data.component
}

function redirectToPage() {
  if (errorPresets[error.value.statusCode].link) {
    clearError({ redirect: String(errorPresets[error.value.statusCode].link) })
  }
}
</script>

<template>
  <div class="container" v-if="error">
    <NuxtErrorBoundary >
      <section class="service">
        <div class="service__wrapper">
          <div v-if="errorPresets[error.statusCode].code" class="service__code">
            {{ errorPresets[error.statusCode].code }}
          </div>
          <MainTitle
            class="service__title"
            :text="errorPresets[error.statusCode].title"
          />
          <div class="service__subtitle">
            {{ errorPresets[error.statusCode].subtitle }}
          </div>
          <AppButton
            class="service__link"
            v-if="errorPresets[error.statusCode].link"
            @click="redirectToPage"
            type="primary"
            text="На главную"
          />
        </div>
        <div class="service__image-container">
          <img
            class="service__image"
            :src="errorPresets[error.statusCode].image"
            alt="error image"
          />
        </div>
      </section>
      <div class="service__component" v-if="errorPresets[error.statusCode]?.component">
        <component :is="errorPresets[error.statusCode].component" />
      </div>
    </NuxtErrorBoundary>
  </div>
</template>

<style lang="scss" scoped>
.container {
  @include xs-breakpoint {
    padding: 0;
    margin-bottom: 0px;
  }
}

.service {
  height: 100%;
  margin-top: 80px;
  display: flex;
  justify-content: center;

  @include sm-breakpoint {
    flex-direction: column-reverse;
    gap: 16px;
    align-items: center;
    padding: 0 20px;
    text-align: -webkit-center;
  }

  &__code {
    color: $content_primary;
    @include font(24px, 28px, 500);
    background-color: $bg_neutral;
    border-radius: 100px;
    padding: 6px 12px;
    width: fit-content;
    @include sm-breakpoint {
      @include font(20px, 24px, 500);
    }
  }

  &__title {
    margin-top: 8px;
  }

  &__subtitle {
    margin-top: 12px;
    @include font(16px, 20px, 400);
  }

  &__link {
    margin-top: 28px;
  }
}
</style>
